import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { paramCase } from "change-case";
import { safe, isNullOrEmpty, isShareDisabled } from "../../utils";
import { IPageProperties } from "../../models";
import { LoadingIcon } from "../../assets/LoadingIcon/LoadingIcon";
import { AddRemoveButton } from "../../components/Watchlist/AddRemoveButton";

const FaAngleDown = require('react-icons/lib/fa/angle-down');
const styles = require('./styles.pcss');
let body = document.querySelector("body");

interface IState {
    visible: boolean;
}

export class PageHeader extends React.Component<IPageProperties, IState>{
    constructor(props) {
        super(props);
        this.state = { visible: false };
        this.toggle = this.toggle.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    toggle() {
        this.setState({ visible: !this.state.visible }, () => {
            this.handleProps();
        });
    }

    componentWillMount() {
        this.handleProps();
    }

    handleProps() {
        if (this.state.visible) {
            this.addEvents();
        } else {
            this.removeEvents();
        }
    }

    addEvents() {
        document.addEventListener('click', this.handleDocumentClick, true);
    }

    removeEvents() {
        document.removeEventListener('click', this.handleDocumentClick, true);
    }

    handleDocumentClick(e) {
        const container = ReactDOM.findDOMNode(this);

        if (container.contains(e.target) && container !== e.target) {
            return;
        }

        this.toggle();
    }

    render() {
        let { isLoading, shareClass, fund, appParams } = this.props;
        let shareClassProperties = safe(() => shareClass.properties, {});
        let visibility = !this.state.visible ? '' : styles.active;

        let internalClasses = {
            caret: `${ styles.caret } ${ visibility }`,
            dropdown: `${ styles.dropdownContent } ${ visibility }`
        }

        if (!fund || !fund.shareClasses || !shareClass) {
            return (
                <div className={ styles.loaderElement }>
                    <div className={ styles.loader }></div>
                    Loading...
                </div>
            );
        }
        let shareClasses = [...fund.shareClasses];
        shareClasses.sort((a, b) => {
            function getSortValue(obj) {
                return safe(() => obj.properties['shareclass_name'], null);
            }
            let aValue = getSortValue(a);
            let bValue = getSortValue(b);
            return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        });

        const showDropdown = !isNullOrEmpty(shareClasses) && shareClasses.length > 1 && appParams.clienttype !== "dtc";

        return (
            <div className={ styles.wrapper }> {/*sets the max width to 960px for the component elements */ }
                <AddRemoveButton { ...this.props } />
                <div className={ styles.dropdown } onClick={ this.toggle }>
                    <button type="button" className={ `${ styles.dropbtn } ${ showDropdown ? "" : styles.dropbtnSingleItem }` } >
                        { shareClassProperties['shareclass_name'] }
                        { showDropdown ? <div className={ internalClasses.caret }><FaAngleDown /></div> : "" }
                    </button>
                    { (() => {
                        if (showDropdown) {
                            return (
                                <div className={ internalClasses.dropdown }>{
                                    shareClasses.map(s => {
                                        if (shareClass.properties.shareclass_name !== s.properties.shareclass_name && !isShareDisabled(s.clientCode)) {
                                            return <a key={ s.clientCode } href={ `${ appParams.baseurl }funds/${ paramCase(s.properties.fund_name) }/${ s.clientCode }/${ appParams.region }/${ appParams.clienttype }/${ appParams.language }` }>{ s.properties['shareclass_name'] }</a>
                                        }
                                    })
                                }</div>
                            );
                        }
                    })() }
                </div>
                <div className={ styles.shareClassSelector }>
                    <p> ISIN: { shareClassProperties['isin'] }</p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/PageHeader/index.tsx